module.exports = __webpack_public_path__ + "img/41.7.Chla.91fe19cd.png";